<template>
	<div class="mapClass" ref="mapClass" :style="{zoom: zoomNum}">
		<img :src="mapUrl" class="mapImg_li" @load="imgSuccess">
		<div id="aaa_li" class="mapPostion_li" v-show="ifDraw" :style="{'transform': `scale(${1/zoomNum})`}">
			<svg class="circle_svg" width="20" height="20" viewBox="0 0 20 20">
				<circle cx="10" cy="10" r="9" fill="none" stroke="#FF0000" stroke-width="0.7"	stroke-opacity="0.3" class="glow_outer" />
				<circle cx="10" cy="10" r="7" fill="none" stroke="#FF0000" stroke-width="0.7"	stroke-opacity="0.5" class="glow_middle" />
				<circle cx="10" cy="10" r="4.7" fill="#FF0000" class="core" />
			</svg>
		</div>
	</div>
</template>

<script>
	import {
		positonInfo
	} from '@/api/user'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				dialogClose: require('../../static/img/close.png'),
				robotSrc: require('../../static/img/xyRobot.png'),
				mapUrl: '',
				robotId: '',
				zoomNum: 0,
				ifDraw: false,
				mFloorEntity: {}
			}
		},
		props: {
			position: {},
			posInfo: {},
			autoHeight: Number,
			autoWidth: Number,
			changeTime: Number
		},
		mounted() {
			let that = this
			this.getPosDetail(that.position)
		},
		methods: {
			getPosDetail(res) {
				let that = this
				that.robotId = res.robotId
				positonInfo({
					robotId: res.robotId,
					userId: getItem('userInfo').staffId
				}).then(res => {
					that.mapUrl = res.data.address
					that.mFloorEntity = res.data
					let vDom = document.getElementById('aaa_li')
					let mapImgDom = document.getElementsByClassName('mapClass')[0]
					let vDomZoomW = document.documentElement.clientWidth * 0.7
					let vDomZoomH = document.documentElement.scrollHeight * 0.8
					mapImgDom.style.width = res.data.width + 'px'
					mapImgDom.style.height = res.data.height + 'px'
					mapImgDom.style.margin = "0 auto"
					if (Number(res.data.width) > Number(res.data.height)) {
						mapImgDom.style.zoom = vDomZoomW / Number(res.data.width)
					} else {
						mapImgDom.style.zoom = vDomZoomH / Number(res.data.height)
					}
					that.countZoom()
				})
			},
			imgSuccess() {
				this.ifDraw = true
			},
			countZoom() {
				let that = this
				let mapImgDom = document.getElementsByClassName('mapClass')[0]
				if (mapImgDom.offsetHeight > mapImgDom.offsetWidth) {
					that.zoomNum = that.autoHeight / mapImgDom.offsetHeight
				} else {
					if ((that.autoWidth / that.autoHeight) > (mapImgDom.offsetWidth / mapImgDom.offsetHeight)) {
						that.zoomNum = that.autoHeight / mapImgDom.offsetHeight
					} else {
						that.zoomNum = that.autoWidth / mapImgDom.offsetWidth
					}
				}
				that.$refs.mapClass.style.zoom = that.zoomNum
			},
			// 计算长度
			calculationWidth(xy) {
				return Math.sqrt((xy.x2 - xy.x1) * (xy.x2 - xy.x1) + (xy.y2 - xy.y1) * (xy.y2 - xy.y1));
			},
			// 计算角度
			calculationRotate(xy) {
				let radian = Math.atan2(xy.y1 - xy.y2, xy.x1 - xy.x2);
				let angle = 180 / Math.PI * radian;
				return angle;
			},
			closeMap() {
				this.$emit('closeRobot', true)
			},
			drawPointFun (rowInfo) {
				let mFloorEntity = this.mFloorEntity
				const mapX = Math.sqrt(Math.pow(rowInfo.x, 2));
				const mapOX = Math.sqrt(Math.pow(mFloorEntity.originX, 2));
				let ax = 0;
				if (rowInfo.x == 0) {
					ax = mapOX;
				} else if (rowInfo.x > 0) {
					ax = mapOX + mapX;
				} else if (rowInfo.x < 0) {
					ax = mapOX - mapX;
				}

				const mapH =  mFloorEntity.height * mFloorEntity.resolution;
				const mapY =  Math.sqrt(Math.pow(rowInfo.y, 2));
				const mapOy = Math.sqrt(Math.pow(mFloorEntity.originY, 2));
				let ay = 0;
				if (rowInfo.y == 0) {
					ay = mapY;
				} else if (rowInfo.y > 0) {
					ay = mapH - mapOy - mapY;
				} else if (rowInfo.y < 0) {
					ay = mapH - mapOy + mapY;
				}

				ax = Number(ax / mFloorEntity.resolution);
				ay = Number(ay / mFloorEntity.resolution);
				return [ax, ay]
			}
		},
		destroyed() {
			// 关闭
		},
		watch: {
			changeTime: {
				deep: true,
				immediate: false,
				handler(newValue, oldValue) {
					let that = this
					if (newValue) {
						that.getPosDetail(that.position)
					}
				}
			},
			posInfo: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					that.$nextTick(() => {
						let vDom = document.getElementById('aaa_li')
						if (newValue.positon && that.robotId === newValue.robotId) {
							vDom.style.left = that.position.robotType == '04' ? that.drawPointFun({
								x: Number(newValue.positon.split(',')[0]),
								y: Number(newValue.positon.split(',')[1])
							})[0] - 10 + 'px' : (Number(newValue.positon.split(',')[0]) - 10) + 'px'
							vDom.style.top = that.position.robotType == '04' ? that.drawPointFun({
								x: Number(newValue.positon.split(',')[0]),
								y: Number(newValue.positon.split(',')[1])
							})[1] - 10 + 'px' : (Number(newValue.positon.split(',')[1]) - 10) + 'px'
							vDom.style.opacity = '1'
						}
					})
				}
			},
			autoHeight: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					if (newValue) {
						that.$nextTick(() => {
							let mapImgDom = document.getElementsByClassName('mapClass')[0]
							if (mapImgDom.offsetHeight > mapImgDom.offsetWidth) {
								that.zoomNum = newValue / mapImgDom.offsetHeight
							}
						})
					}
				}
			},
			autoWidth: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					if (newValue) {
						that.$nextTick(() => {
							let mapImgDom = document.getElementsByClassName('mapClass')[0]
							if (mapImgDom.offsetWidth >= mapImgDom.offsetHeight) {
								if ((newValue / that.autoHeight) > (mapImgDom.offsetWidth / mapImgDom
									.offsetHeight)) {
									that.zoomNum = that.autoHeight / mapImgDom.offsetHeight
								} else {
									that.zoomNum = newValue / mapImgDom.offsetWidth
								}
							}
						})
					}
				}
			},
			position: {
			  immediate: false,
			  handler(newValue, oldValue) {
				let that = this
				that.getPosDetail(newValue)
			  }
			}
		}
	}
</script>

<style scoped lang="less">
	@keyframes icon {
		0% {
			transform: translate(0, 0)
		}

		50% {
			transform: translate(0px, -10px)
		}

		100% {
			transform: translate(0, 0)
		}
	}

	.pointClass {
		width: 3px;
		height: 3px;
		background-color: black;
		border-radius: 50%;
		position: absolute;
	}

	.linesClass {
		position: absolute;
		height: 1px;
		border-top: 2px solid red;
	}
	.mapClass {
		position: relative;
	}

	.mapImg_li {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}

	.mapClose {
		position: absolute;
		width: 30px;
		height: 30px;
		top: -15px;
		right: -15px;
		cursor: pointer;
	}

	.mapPostion_li {
		border-radius: 50%;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
		width: 20px;
		height: 20px;
		margin-left: -10px;
		margin-top: -10px;
		display: flex;
		align-items: center;
		justify-content: center;
		.circle_svg {
			width: 100%;
			height: 100%;
			.glow_outer {
				animation: outer-glow 2s ease-in-out infinite;
			}
			.glow_middle {
				animation: middle-glow 2s ease-in-out infinite;
			}
			.core {
				animation: core-pulse 2s ease-in-out infinite;
			}
		}

		@keyframes outer-glow {
			0% {
				stroke-opacity: 0.1;
				stroke-width: 0.3;
			}
			50% {
				stroke-opacity: 0.4;
				stroke-width: 0.9;
			}
			100% {
				stroke-opacity: 0.1;
				stroke-width: 0.3;
			}
		}

		@keyframes middle-glow {
			0% {
				stroke-opacity: 0.3;
				stroke-width: 0.3;
			}
			50% {
				stroke-opacity: 0.7;
				stroke-width: 0.9;
			}
			100% {
				stroke-opacity: 0.3;
				stroke-width: 0.3;
			}
		}
		@keyframes core-pulse {
			0% {
				fill-opacity: 0.5;
			}
			50% {
				fill-opacity: 0.8;
			}
			100% {
				fill-opacity: 0.5;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/RobotMapLiInfo.vue